import React from 'react';
import { ColorRing } from 'react-loader-spinner';

const Loading = () => {
  return (
    <div
      style={{
        position: 'fixed', // stays over everything
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 999999, // above all layers
        backgroundColor: 'rgba(255, 255, 255, 0.7)', // blurred background
        backdropFilter: 'blur(4px)', // apply blur
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ColorRing
        visible={true}
        height="100"
        width="100"
        ariaLabel="blocks-loading"
        wrapperClassName="blocks-wrapper"
        wrapperStyle={{}}
        colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
      />
    </div>
  );
};

export default Loading;
